var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isMobile)?_c('div',{ref:"mobileTip",staticClass:"mobile-tip"},[_c('span',{staticClass:"tip-text"},[_vm._v("请在电脑端网页浏览器中使用 (推荐Chrome)")]),_c('button',{staticClass:"copy-button",on:{"click":_vm.copyLink}},[_vm._v("复制链接")])]):_vm._e(),(_vm.shouldShowChat)?_c('AIChatWindow'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }